import { inject, Pipe, PipeTransform } from '@angular/core';
import { SystemDateFormatService } from '@/core/service/system-date-format.service';

@Pipe({ name: 'dateTime', standalone: true, pure: true })
export class DateTimesPipe implements PipeTransform {
    private dateService = inject(SystemDateFormatService);

    transform(value?: Date | string | null): string {
        return this.dateService.formatDateTime(value);
    }
}
